import { Get } from 'Xhr/Xhr';
import { env } from 'env';
import React, { useEffect, useState } from 'react';

const useGetLanguages = (standard = false) => {
  const [response, getResponse] = useState();
  useEffect(() => {
    Get(
      `${process.env.REACT_APP_API_URL_API_LANG_LANGLIST_KEY}`,
      false,
      {}
    ).then((response) => {
      getResponse(response.data.Data);
    });
  }, []);
  function convertToLocaleNames(locales) {
    return locales?.map((locale) => {
      let displayName = new Intl.DisplayNames([locale], {
        type: 'language',
      }).of(locale);
      let languageName = displayName.split(' (')[0];
      return (
        languageName.split(' ')[1] ||
        languageName.split(' ')[0]
      );
    });
  }

  const localizedLangNames = convertToLocaleNames(response);

  const languageDataArray = localizedLangNames?.map(
    (lang, index) => ({
      ItemContent: lang,
      ItemValue: standard
        ? response[index]
        : response[index]?.split('-')[0],
    })
  );

  return languageDataArray;
};

export default useGetLanguages;
